module.exports = __webpack_public_path__ + "static/media/InfoOutline.ce93d58c.svg";